// extracted by mini-css-extract-plugin
export default {"container":"AssignModal_container__Viu5N","subTitle":"AssignModal_subTitle__V0rwa"};